import React, { useEffect, useState } from "react";
import "./QuestionType.css";
import CheckBoxType from "./CheckBoxType";
import CheckBoxTypeSA from "../../../SelfAssessment/Completed/CheckBoxType";
import SucessfullySubmited from "./SucessfullySubmited";
import SubmisshionByUpload from "./SubmisshionByUpload";
import { useSelector } from "react-redux";
import axios from "../../../../axios";
import { useNavigate, useLocation, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import SuccessfullyUpdatedAssessement from "../../../SelfAssessment/Popup/SuccessfullyUpdatedAssessement";
import AllQuestionRequired from "../../../SelfAssessment/Popup/AllQuestionRequired";
import { assessmentTimeHelper, assessmentDateHelper } from "../../../../utils/datetime_helper";

export default function AllQuestions({ type }) {
  const { assessmentId, selfAssessmentId } = useParams();
  const [pendingData, setPendingData] = useState([]);
  const { state } = useLocation()
  const [studentResponse, setStudentResponse] = useState();
  const [responseAnswers, setResponseAnswers] = useState([]);
  const [isGettingData, setIsGettingData] = useState(true);
  const [isLoading, setIsLoading] = useState(false);
  const [questionsAnswer, setQuestionsAnswer] = useState([]);
  const [currencyQuestionAnswer, setCurrentQuestionAnswer] = useState(null);
  const [questionNo, setQuestionNo] = useState(0);
  const [selfAssessmentUpdated, setSelfAssessmentUpdated] = useState(false);
  const [isNotAllQuestionAnswered, setIsNotAllQuestionAnswered] = useState(false)
  const [allQuestions, setAllQuestions] = useState([]);
  const [disableSubmitButton, setDisableSubmitButton] = useState(false)

  const [allQuestion, setAllQuestion] = useState({
    sucessful: false,
  });
  const userId = useSelector((state) => state.user?.currentUser?.id);
  const navigate = useNavigate();
  const getStudentResponse = async () => {
    try {
      let res = await axios.get(
        `assessment/${state.assessmentId}/studentResponse/student/${userId}/get`
      );

      res && setStudentResponse(res.data.data);
      setIsGettingData(false);
      setResponseAnswers(res?.data?.data?.answers);
    } catch (error) {
      setIsGettingData(false);
      console.log(error);
    }
  };

  const getSAAnswerResponse = async () => {
    try {
      let res = await axios.get(
        `selfAssess/${state.selfAssessmentId}/studentResponse/student/${userId}/get`
      );
      res && setStudentResponse(res.data.data);
      setIsGettingData(false);
      setResponseAnswers(res?.data?.data?.answers);
      setCurrentQuestionAnswer(res?.data?.data?.answers[questionNo])
      setQuestionsAnswer([...res?.data?.data?.answers]);
    } catch (error) {
      setIsGettingData(false);
      console.log(error);
    }
  };

  const getSAQuestionResponse = async () => {
    try {
      let updatedQuestion = [];
      let tempAllQuestion = [];
      let res = await axios.get(`/selfAssess/get/${state.selfAssessmentId}`);
      // console.log("res>test", res)
      if (res.data.data?.questions.length == 0 && res.data.data?.b4sQuestions.length == 0) {
        toast.info("Qustions not available");
        navigate(-1)
        return false;
      } else {
        // b4sQuestions
        res &&
          res.data.data?.questions.forEach((question, index) => {
            // console.log("question", question)
            tempAllQuestion.push(question)
            if (!question.type.is_manually_graded) {
              updatedQuestion.push({
                question_id: question?.id,
                questionSource: "question",
                options: {
                  key: " ",
                  explanation: " ",
                },
                mandatory: question?.is_mandatory,
                index,
              });
            } else {
              updatedQuestion.push({
                question_id: question?.id,
                questionSource: "question",
                description: " ",
                attachments: [],
                mandatory: question?.is_mandatory,
                index,
              });
            }
          });
        res.data.data?.b4sQuestions.forEach((question, index) => {
          tempAllQuestion.push(question)
          if (!question.type.is_manually_graded) {
            updatedQuestion.push({
              question_id: question?.id,
              questionSource: "b4s",
              options: {
                key: " ",
                explanation: " ",
              },
              mandatory: question?.is_mandatory,
              index,
            });
          } else {
            updatedQuestion.push({
              question_id: question?.id,
              questionSource: "b4s",
              description: " ",
              attachments: [],
              mandatory: question?.is_mandatory,
              index,
            });
          }
        });
        setAllQuestions(tempAllQuestion);
        res && setPendingData([...updatedQuestion]);
      }

    } catch (error) {
      toast.error(error);
      console.log(error);
    }
  };

  useEffect(() => {
    if (type == "SA") {
      getSAQuestionResponse();
      getSAAnswerResponse();
    } else {
      getStudentResponse();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selfAssessmentUpdated]);



  const timeHelper = (a) => {
    const dateObj = new Date(a);
    const userOffset = dateObj.getTimezoneOffset() * 60000; // Convert minutes to milliseconds
    const localDate = new Date(dateObj - userOffset); // Convert to local time

    const day = localDate.getDate().toString().padStart(2, "0");
    const month = (localDate.getMonth() + 1).toString().padStart(2, "0");
    const year = localDate.getFullYear();
    const outputDateString = `${day}/${month}/${year}`;
    return outputDateString;
  };

  const handleSubmit = async () => {
    try {
      // let updateReqeustObject = {
      //   "submitted_on": studentResponse.submitted_on,
      //   "student_id": userId,
      //   "answers": []
      // };
      // questionsAnswer.map((answer) => {
      //   updateReqeustObject['answers'].push({
      //     "id": answer.id,
      //     "question_id": answer.question.id,
      //     "answer": answer.answer
      //   })
      // })
      setDisableSubmitButton(true)
      setIsLoading(true)
      let qustionAnswer = [];
      let b4sQuestionAnswer = [];
      // b4sQuestions
      // questionsAnswer.forEach((answer) => {
      //   pendingData.map((type) => {
      //     if (type?.questionSource === 'b4s') {
      //       b4sQuestionAnswer.push({
      //         id: answer.id,
      //         question_id: answer.b4sQuestion.id,
      //         answer: answer.answer
      //       })
      //     } else {
      //       qustionAnswer.push({
      //         id: answer.id,
      //         question_id: answer.question.id,
      //         answer: answer.answer
      //       })
      //     }
      //   })
      // })
      questionsAnswer.forEach((answer) => {
        if (answer?.b4sQuestion) {
          b4sQuestionAnswer.push({
            id: answer.id,
            question_id: answer.b4sQuestion.id,
            answer: answer.answer
          });
        } else {
          qustionAnswer.push({
            id: answer.id,
            question_id: answer.question.id,
            answer: answer.answer
          });
        }
      });
      let selfAssessmentBody = {
        student_id: userId,
        submitted_on: new Date(),
        b4squestionanswers: b4sQuestionAnswer,
      };
      let notAnswer = questionsAnswer.filter(
        (answer) => answer.answer.key == " "
      );
      if (notAnswer.length > 0) {
        setIsNotAllQuestionAnswered(true);
        return;
      }
      let res = await axios.post(`/selfAssess/${state.selfAssessmentId}/studentResponse/update`, selfAssessmentBody);
      setSelfAssessmentUpdated(true);

      if (res) {
        setIsLoading(false)
        setAllQuestion({ ...allQuestion, sucessful: true });
      }

    } catch (error) {
      setIsLoading(false)
      // toast.error(error?.response?.data?.message ?? "Something went wrong")
      console.log(error);
    } finally {
      setDisableSubmitButton(false)
    }
  };

  const handleSucessfulyfalse = () => {
    setAllQuestion({
      ...allQuestion,
      sucessful: false,
    });
  };

  return (
    <>
      {studentResponse ? (
        <div className="ContainerQuestion d-flex p-4 gap-1">
          <div>
            <img
              style={{ cursor: "pointer" }}
              onClick={() => window.history.back()}
              src="/HwImg/backArrow.png"
              alt=""
            />{" "}
            &nbsp;
          </div>
          <div className="hederContainer1">
            <div>
              <div className="d-flex justify-content-between w-100  ">
                <div className="d-flex gap-2">
                  <span className="quesHeading">
                    {type == "SA" ? studentResponse?.selfAssess?.name : studentResponse?.assessment?.name}
                  </span>
                  <div className="penddingButton">On Review</div>
                </div>
                <div>
                  {/* <div>
                    <span className="subTitles">Results</span> &nbsp;
                    <span className="quesHeading">-/-</span>
                  </div> */}
                </div>
              </div>
              <div className="d-flex justify-content-between w-100 mt-4">
                <div className="d-flex">
                  <div>
                    <span className="subTitle2">
                      {type == "SA" ? studentResponse?.selfAssess?.subject_id?.name : studentResponse?.assessment?.subject?.name}
                    </span>
                    &nbsp;
                    {
                      type !== "SA" ? <><span>|</span> &nbsp;
                        <span className="subTitles3">Scheduled On</span> &nbsp;
                        <span className="subTitle2">
                          {/* {timeHelper(studentResponse?.assessment?.deadline)} */}
                          {assessmentDateHelper(studentResponse?.assessment?.schedule_date)}{" - "}
                          {assessmentTimeHelper(studentResponse?.assessment?.schedule_time)}
                        </span>
                        &nbsp;</> : null
                    }

                  </div>
                  <div>
                    <span>|</span> &nbsp;
                    <span className="subTitles3">Submitted</span> &nbsp;
                    <span className="subTitle2">
                      {timeHelper(studentResponse?.submitted_on)}
                    </span>
                    &nbsp;
                  </div>
                </div>
                <div className=" ">
                  <div className="quesHeading d-flex justify-content-center">
                    Questions:  {questionNo + 1}/{studentResponse?.answers?.length}
                  </div>
                  <div>
                    <span className="subTitles">Total Marks</span> &nbsp;
                    <span className="quesHeading">
                      {type == "SA" ? studentResponse?.selfAssess?.total_marks : studentResponse?.assessment?.total_marks}
                    </span>
                  </div>
                  <div>
                    <span className="subTitles">This Question</span> &nbsp;
                    <span className="quesHeading">{questionNo + 1}</span>
                  </div>
                </div>
              </div>
            </div>
            <div style={{ fontSize: "18px", fontWeight: "500", margin: "15px 0px" }}>{studentResponse?.assessment?.description}</div>
            <div className="mt-3 d-flex gap-2" style={{ overflowX: "auto" }}>
              {responseAnswers?.length > 0 &&
                responseAnswers?.map((item, index) => (
                  <div
                    key={index}
                    onClick={(e) => setQuestionNo(index)}
                    className={
                      questionNo > index
                        ? "QuestionActiveNo"
                        : "QuestionNoNonActive"
                    }
                    style={{
                      borderColor: item.is_mandatory
                        ? "#AC1616"
                        : questionNo === index
                          ? "#F99933"
                          : questionNo > index
                            ? "#F77F00"
                            : "#668598",
                      color:
                        questionNo === index
                          ? "#F99933"
                          : questionNo > index
                            ? "#F77F00"
                            : "#668598",
                      backgroundColor:
                        questionNo > index ? "#FEF2E5" : "transparent",
                      minWidth: "30px",
                    }}
                  >
                    Q{index + 1}
                  </div>
                ))}
            </div>
            <div className="mt-4 allquestionTypesContainer">
              {!responseAnswers[questionNo]?.question?.type
                ?.is_manually_graded ? (
                type == "SA" ?
                  <CheckBoxTypeSA
                    type={type}
                    key={currencyQuestionAnswer.id + "-" + currencyQuestionAnswer.answer.key}
                    responseAnswers={currencyQuestionAnswer}
                    questionNo={questionNo + 1}
                    questionsAnswer={questionsAnswer}
                    setQuestionsAnswer={setQuestionsAnswer}
                  /> :
                  <CheckBoxType
                    questionNo={questionNo + 1}
                    response={responseAnswers[questionNo]}
                  />
              ) : (
                <SubmisshionByUpload
                  questionNo={questionNo + 1}
                  response={responseAnswers[questionNo]}
                />
              )}

              <div>
                <div className="d-flex gap-2 justify-content-end nextBtnContainer">
                  {questionNo >= 1 && (
                    <button
                      className="PreviousBtnQue"
                      onClick={(e) => setQuestionNo(questionNo - 1)}
                    >
                      Previous
                    </button>
                  )}

                  {
                    responseAnswers?.length > questionNo + 1 ?
                      <button
                        className="nextBtnQue"
                        onClick={(e) => { setQuestionNo(questionNo + 1); setCurrentQuestionAnswer(questionsAnswer[questionNo]) }}
                      >
                        Next
                      </button> :
                      type == "SA" ? <button
                        className="nextBtnQue"
                        disabl={disableSubmitButton}
                        style={{
                          background: disableSubmitButton ? '#f1aa5e' : '#F77F00',
                          cursor: disableSubmitButton && 'not-allowed'
                        }}
                        onClick={() => {
                          let assId = state.selfAssessmentId;
                          let assType = "selfAssess"
                          handleSubmit(assId, assType);
                        }}
                      >
                        Submit
                      </button> : null
                  }
                </div>
              </div>
            </div>
          </div>

          {allQuestion.sucessful && (
            <SucessfullySubmited
              // handleQuestionfalse={handleQuestionfalse}
              handleSucessfulyfalse={handleSucessfulyfalse}
            />
          )}
          {selfAssessmentUpdated && (
            <SuccessfullyUpdatedAssessement
              // handleQuestionfalse={handleQuestionfalse}
              setSelfAssessmentUpdated={setSelfAssessmentUpdated}
            />
          )}
          {isNotAllQuestionAnswered && (
            <AllQuestionRequired
              setIsNotAllQuestionAnswered={setIsNotAllQuestionAnswered}
            />
          )}
          {isLoading && (
            <div className="loader-overlay">
              <img
                className="ongoing_internal_loader-self-ass"
                src="/gif/LoaderDot.gif"
                alt="Loading..."
              />
            </div>
          )}
        </div>
      ) : isGettingData ? (
        <div className="ContainerPendingSubDetail d-flex p-4 gap-1">
          <img
            className="ongoing_internal_loader"
            src="/gif/LoaderDot.gif"
            alt=""
          />
        </div>
      ) : (
        <div className="ContainerPendingSubDetail d-flex p-4 gap-1">
          <span>Assessment Not Found</span>
        </div>
      )}
      {console.log("isLoading", isLoading)}

    </>

  );
}
